import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
import { Waypoint } from 'react-waypoint';
import { Container } from 'reactstrap';
import { injectIntl } from 'react-intl';

import { showModal } from '../actions';
import {
  setUserSetting,
  updateUserSettings,
} from '../actions/Auth';
import {
  fetchCollection,
  clearCollection,
  fetchCollections,
  clearCollections,
  setCollectionsParams,
  addSelectedCollection,
  removeSelectedCollection,
  clearSelectedCollections,
  clearCollectionsList,
  setCollectionsLoading,
} from '../actions/Collections';
import {
  fetchFiles,
  clearFiles,
  clearFilesList,
  setCollectionUuid,
  setFilesParams,
  clearFilesFilters,
  clearSelectedFilters,
  setFilesGroupUuid,
  fetchFilesGroup,
  clearFilesGroup,
  addSelectedFile,
  removeSelectedFile,
  clearSelectedFiles,
  fetchDownload,
  setDownloadUuid,
  clearDownload,
  setFilesSearchType,
  setFilesLoading,
} from '../actions/Files';
import { setSearchTerm } from '../actions/Search';

import { APIgetFile } from '../api/Files';

import CollectionAddModal from '../components/Collections/AddModalV2';
import CollectionReorder from '../components/Collections/Reorder';
import FilesHeader from '../components/Files/Header';
import FilesHeaderBackLink from '../components/Files/HeaderBackLink';
import FilesFilters from '../components/Files/Filters';
import FilesGrid from '../components/Files/Grid';
import FilesList from '../components/Files/List';
import FilesMasonry from '../components/Files/Masonry';
import FilesTile from '../components/Files/Tile';
import Sort from '../components/Filters/Sort';
import ViewMode from '../components/Filters/ViewMode';
import ArchiveHeader from '../components/ArchiveHeader';
import ArchiveSearchHeader from '../components/ArchiveSearchHeader';
import CollectionPreview from '../components/CollectionPreview';
import CollectionsSection from './CollectionsSection';
import FilesSelectAll from '../components/Files/SelectAll';
import CustomDragLayer from '../components/CustomDragLayer';
import EmptyCollection from './EmptyContainers/Collection';
import EmptySearch from './EmptyContainers/Search';
import EmptySmartCollection from './EmptyContainers/SmartCollection';
import MiniHeader from '../mini/components/Header';
import FilesMiniMasonry from '../mini/components/Files/Masonry';
import MiniEmptyCollection from '../mini/components/EmptyCollection';
import TrashHeader from '../components/TrashHeader';
import Loading from '../components/Loading';

import { getUrlParam } from '../helpers';
import {
  isArchive,
  isFavorites,
  isMini,
  isTrash,
  resizeSplitContentContainer,
} from '../helpers/App';
import { getCurrentUser, userCan } from '../helpers/Auth';
import ItemTypes from '../helpers/DNDItemTypes';
import {
  getFilesView,
  isAllFilesPage,
} from '../helpers/Files';
import { getUserSetting } from '../helpers/Settings';
import { getDefaultSortParams } from '../helpers/Sort';

import SelectionArea from '../lib/viselect/viselect';

class Files extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filesExpanded: true,
      relatedFile: null,
    };

    this.ds = null;

    this.switchFiles = this.switchFiles.bind(this);
    this.handleMoveSelectedItems = this.handleMoveSelectedItems.bind(this);
    this.setOrder = this.setOrder.bind(this);
    this.setFilesView = this.setFilesView.bind(this);
    this.setCollectionsView = this.setCollectionsView.bind(this);
  }

  componentDidMount() {
    const {
      match,
      history,
      dispatch,
    } = this.props;
    const { relatedFile } = this.state;

    dispatch(setFilesSearchType('new'));
    resizeSplitContentContainer();

    if (isArchive()) {
      if (!userCan('file.archive') && !userCan('file.browse_archived')) {
        history.push('/files');
      }
    }

    if (
      !relatedFile ||
      (match.params.relatedFileId && relatedFile.uuid !== match.params.relatedFileId)
    ) {
      this.loadRelatedFile();
    }

    if (!match.params.fileId) {
      if (getUrlParam('search')) {
        dispatch(setSearchTerm(getUrlParam('search')));
      } else {
        dispatch(setSearchTerm(null));
      }
      this.clearFiles();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      dispatch,
      match,
      files,
    } = this.props;
    if (!this.ds && !isMini()) {
      this.ds = new SelectionArea({
        selectables: [
          '.files-grid > .grid-item',
          'table.files-list tr',
          '.files-masonry .masonry-item',
          '.collections .collections-item',
          'table.collections-list tr',
        ],
        startareas: [
          '.files-grid',
          '.files-list',
          '.files-masonry',
        ],
        boundaries: ['.main-content .container-fluid'],
        container: '.draggable-container .main-wrapper',
        behaviour: {
          overlap: 'keep',
        },
        features: {
          touch: false,
          singleTap: {
            allow: false,
          },
        },
      })
        .on('beforestart', ({ event }) => {
          if (
            event.target.closest('.collections-item') ||
            event.target.closest('.grid-item') ||
            event.target.closest('.masonry-item') ||
            event.target.closest('.list-item') ||
            this.isReordering()
          ) {
            return false;
          }
          return true;
        })
        .on('start', ({ event }) => {
          if (!event.metaKey) {
            dispatch(clearSelectedFiles());
            dispatch(clearSelectedCollections());
          }
        })
        .on('move', ({ store: { changed: { added, removed } } }) => {
          added.forEach((s) => {
            const file = this.getFileById(s.id);
            if (file) {
              dispatch(addSelectedFile(file));
            } else {
              const collection = this.getCollectionById(s.id);
              if (collection) {
                dispatch(addSelectedCollection(collection));
              }
            }
          });
          removed.forEach((s) => {
            dispatch(removeSelectedFile(s.id));
            dispatch(removeSelectedCollection(s.id));
          });
        })
        .on('stop', () => {
          this.ds.clearSelection();
        });
    }

    if (match.params.collectionId !== prevProps.match.params.collectionId) {
      if (!prevProps.match.params.collectionId) {
        dispatch(clearFilesFilters());
        dispatch(clearSelectedFilters());
      }
      this.clearFiles();
      return;
    }

    if (match.params.groupId !== prevProps.match.params.groupId) {
      this.clearFiles();
      return;
    }

    if (match.params.relatedFileId !== prevProps.match.params.relatedFileId) {
      this.clearFiles();
      return;
    }

    if (files !== prevProps.files && this.ds) {
      this.ds.resolveSelectables();
    }

    const urlParams = this.getUrlParams();
    if (urlParams.length > 0) {
      const prevUrlParams = prevProps.location.pathname.replace(/^[/]+|[/]+$/g, '').split('/');
      if (prevUrlParams.length > 0) {
        if (urlParams[0] !== prevUrlParams[0]) {
          if ([
            'files',
            'collections',
            'groups',
            'uploads',
            'archive',
            'favorites',
            'trash',
          ].includes(urlParams[0])) {
            this.clearFiles();
          }
        }
      }
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(clearFiles());
    dispatch(clearFilesFilters());
    dispatch(clearCollection());
    const sortParams = getDefaultSortParams('collections', 'position', 'asc');
    dispatch(clearCollections(sortParams));
    dispatch(setCollectionsParams({
      collectionUuid: null,
    }));
    dispatch(setCollectionUuid(null));
    dispatch(setFilesGroupUuid(null));
    dispatch(clearFilesGroup());
    dispatch(setDownloadUuid(null));
    dispatch(clearDownload());
    if (this.ds) {
      this.ds.destroy();
    }
  }

  getFileById(id) {
    const { files } = this.props;
    return files.find(f => (f.uuid === id));
  }

  getCollectionById(id) {
    const { collections } = this.props;
    return collections.find(c => (c.uuid === id));
  }

  getLoadedFilesLabel() {
    const {
      files,
      filesTotal,
      intl,
    } = this.props;

    if (filesTotal === 0) {
      return null;
    }

    return intl.formatMessage({
      defaultMessage: '({files} of {filesTotal})',
    }, { files: files.length, filesTotal });
  }

  getUrlParams() {
    const { location } = this.props;
    return location.pathname.replace(/^[/]+|[/]+$/g, '').split('/');
  }

  isReordering() {
    const { reorderingMode } = this.props;
    return reorderingMode;
  }

  isSingleFile() {
    const { match } = this.props;
    if (match.params.fileId) {
      return true;
    }
    return false;
  }

  clearFiles() {
    const {
      dispatch,
      match,
      history,
      location,
      search,
      filesParams,
      collection,
    } = this.props;

    if (
      !getUrlParam('search') ||
      (location.state && location.state.fromCollectionPreview)
    ) {
      dispatch(clearFilesFilters());
      dispatch(clearSelectedFilters());
    }
    if (search) {
      dispatch(clearFilesList());
    } else {
      dispatch(clearFiles());
    }

    const filesOrder = {};
    if (collection) {
      filesOrder.orderby = filesParams.orderby;
      filesOrder.order = filesParams.order;
    }

    dispatch(setCollectionUuid(null));
    dispatch(clearCollection());
    const collectionsSortParams = getDefaultSortParams('collections', 'position', 'asc');
    dispatch(clearCollections(collectionsSortParams));
    dispatch(setFilesGroupUuid(null));
    dispatch(clearFilesGroup());
    dispatch(setDownloadUuid(null));
    dispatch(clearDownload());

    this.setState({ filesExpanded: true });

    const filesSortParams = getDefaultSortParams('files', 'position', 'asc');

    if (match.params.collectionId) {
      dispatch(setFilesParams({
        orderby: filesOrder.orderby || filesSortParams.orderby,
        order: filesOrder.order || filesSortParams.order,
      }));
      dispatch(setCollectionsParams({
        collectionUuid: match.params.collectionId,
      }));
      dispatch(fetchCollections());
      dispatch(setCollectionUuid(match.params.collectionId));
      dispatch(fetchCollection(match.params.collectionId, { skip_descendants: true }))
        .then((fetchedCollection) => {
          if (isArchive() && !fetchedCollection.archived) {
            history.push(`/collections/${fetchedCollection.uuid}`);
          }
          if (!isArchive() && fetchedCollection.archived) {
            history.push(`/archive/collections/${fetchedCollection.uuid}`);
          }
        })
        .catch(() => {
          history.push('/collections');
        });
    } else if (isFavorites()) {
      dispatch(setFilesParams({
        orderby: filesSortParams.orderby,
        order: filesSortParams.order,
      }));
      dispatch(setCollectionsParams({
        favorites: true,
      }));
      dispatch(fetchCollections());
    } else if (isTrash()) {
      dispatch(setFilesParams({
        orderby: filesSortParams.orderby,
        order: filesSortParams.order,
      }));
      dispatch(fetchCollections());
    } else if (match.params.groupId) {
      dispatch(setFilesParams({
        orderby: 'date',
        order: 'desc',
      }));
      dispatch(setFilesGroupUuid(match.params.groupId));
      dispatch(fetchFilesGroup(match.params.groupId))
        .catch(() => {
          history.push('/files');
        });
    } else if (match.params.downloadId) {
      dispatch(setFilesParams({
        orderby: 'date',
        order: 'desc',
      }));
      dispatch(setDownloadUuid(match.params.downloadId));
      dispatch(fetchDownload(match.params.downloadId))
        .catch(() => {
          history.push('/files');
        });
    } else {
      dispatch(setFilesParams({
        orderby: filesSortParams.orderby,
        order: filesSortParams.order,
      }));
    }

    if (match.params.relatedFileId) {
      dispatch(setFilesParams({
        fileUuid: match.params.relatedFileId,
      }));
    } else {
      this.setState({ relatedFile: null });
      dispatch(setFilesParams({
        fileUuid: null,
      }));
    }

    dispatch(fetchFiles());
  }

  loadRelatedFile() {
    const { match } = this.props;

    if (!match.params.relatedFileId) {
      this.setState({ relatedFile: null });
    } else {
      APIgetFile(match.params.relatedFileId).then((response) => {
        if (response && response.data) {
          this.setState({ relatedFile: response.data });
        } else {
          this.setState({ relatedFile: null });
        }
      });
    }
  }

  switchFiles(e) {
    e.preventDefault();
    this.setState(prevState => ({ filesExpanded: !prevState.filesExpanded }));
  }

  handleMoveSelectedItems(targetCollectionUuid, droppedItem) {
    const {
      dispatch,
      selectedFiles,
      selectedCollections,
      collection,
    } = this.props;

    const files = selectedFiles.map(sf => (sf.uuid));
    const collections = selectedCollections.map(sc => (sc.uuid));
    if (files.length === 0 && collections.length === 0) {
      if (droppedItem.type === ItemTypes.FILE) {
        files.push(droppedItem.id);
      }
      if (droppedItem.type === ItemTypes.COLLECTION) {
        collections.push(droppedItem.id);
      }
    }

    dispatch(showModal('MoveItemsModal', {
      className: 'modal-move-items',
      targetCollectionUuid,
      currentCollectionUuid: collection.uuid,
      collections,
      files,
      backdrop: false,
    }));
  }

  setOrder(orderby, order) {
    const { dispatch } = this.props;

    dispatch(clearFiles());
    dispatch(setFilesParams({
      orderby,
      order,
      page: 0,
    }));
    dispatch(fetchFiles());
    dispatch(setCollectionsParams({ page: 0 }));
    dispatch(clearCollectionsList());
    dispatch(clearSelectedCollections());
    dispatch(fetchCollections());
  }

  setFilesView(view) {
    const { dispatch } = this.props;

    const profile = getCurrentUser();
    if (profile) {
      dispatch(clearFilesList());
      dispatch(setFilesLoading(true));
      dispatch(setUserSetting({ files_view: view }));
      dispatch(updateUserSettings(profile.uuid, { files_view: view })).then(() => {
        dispatch(setFilesParams({ page: 0 }));
        dispatch(fetchFiles());
      });
    }
  }

  setCollectionsView(view) {
    const { dispatch } = this.props;

    const profile = getCurrentUser();
    if (profile) {
      dispatch(clearCollectionsList());
      dispatch(setCollectionsLoading(true));
      dispatch(setUserSetting({ collections_view: view }));
      dispatch(updateUserSettings(profile.uuid, { collections_view: view })).then(() => {
        dispatch(setCollectionsParams({ page: 0 }));
        dispatch(fetchCollections());
      });
    }
  }

  render() {
    const {
      intl,
      dispatch,
      match,
      files,
      filesLoading,
      filesEnd,
      filesParams,
      sidebarCollectionOpen,
      search,
      selectedFilters,
      collection,
      collections,
      collectionsPage,
      collectionsLoading,
    } = this.props;
    const {
      filesExpanded,
      relatedFile,
    } = this.state;
    const {
      orderby,
      order,
    } = filesParams;
    const filesView = getFilesView();
    const loadedFiles = files.length;
    const initialCollectionsLoading = collectionsLoading && collectionsPage === 0;
    const noFilesFound = filesEnd && !initialCollectionsLoading;

    return (
      <div className={classnames('main-content', 'split-content', 'page-files', {
        'split-content-active': sidebarCollectionOpen && !isArchive(),
        'archive-content': isArchive(),
        'trash-content': isTrash(),
      })}
      >
        {!isMini() && (
          <>
            <ArchiveHeader />
            <TrashHeader />
          </>
        )}
        {(!isMini() && search) && (
          <ArchiveSearchHeader />
        )}
        <div className="split-content-wrapper">
          <Container fluid className="draggable-container">
            {isMini() ? (
              <>
                <MiniHeader />
                <FilesFilters />
              </>
            ) : (
              <>
                <FilesHeader relatedFile={relatedFile} handleClearFiles={() => this.clearFiles()} />
                <FilesHeaderBackLink />
                <FilesFilters />
              </>
            )}
            <div className="main-wrapper">
              {((selectedFilters.length === 0 || search) && !isAllFilesPage()) && (
                <CollectionsSection
                  initialCollectionsLoading={initialCollectionsLoading}
                  handleMoveSelectedItems={this.handleMoveSelectedItems}
                  setOrder={this.setOrder}
                  setCollectionsView={this.setCollectionsView}
                />
              )}
              {(
                (match.params.collectionId || isFavorites()) &&
                !filesLoading &&
                !(filesEnd && loadedFiles === 0)
                && !isMini()
              ) && (
                <div className="collection-tools">
                  <div className="list-switch">
                    <a
                      href="#files-switch"
                      onClick={this.switchFiles}
                    >
                      {intl.formatMessage({
                        defaultMessage: 'Files {label}',
                      }, { label: this.getLoadedFilesLabel() })}{' '}
                      {filesExpanded ? (
                        <i className="far fa-chevron-down" />
                      ) : (
                        <i className="far fa-chevron-right" />
                      )}
                    </a>
                  </div>
                  {(loadedFiles > 0 && filesExpanded) && (
                    <div className="collection-tools-actions">
                      {!isFavorites() && (
                        <div className="collection-tools-actions-buttons">
                          <Sort
                            orderby={orderby}
                            order={order}
                            search={search}
                            setOrder={this.setOrder}
                            collection={collection}
                            size="sm"
                          />
                          <ViewMode
                            view={filesView}
                            setView={this.setFilesView}
                            size="sm"
                          />
                          <CollectionReorder
                            size="sm"
                          />
                        </div>
                      )}
                      <FilesSelectAll />
                    </div>
                  )}
                </div>
              )}
              {filesExpanded && (
              <>
                {(files.length > 0 || filesLoading) ? (
                  <div className="files-container">
                    {isMini() ? (
                      getUserSetting('files_mini_view') === 'masonry' && (
                        <FilesMiniMasonry
                          files={files}
                        />
                      )
                    ) : (
                      <>
                        {['grid', 'framed'].includes(filesView) && (
                          <FilesGrid
                            files={files}
                            handleMoveSelectedItems={this.handleMoveSelectedItems}
                            selectedView={filesView}
                          />
                        )}
                        {filesView === 'list' && (
                          <FilesList
                            files={files}
                            handleMoveSelectedItems={this.handleMoveSelectedItems}
                          />
                        )}
                        {filesView === 'masonry' && (
                          <FilesMasonry
                            files={files}
                            handleMoveSelectedItems={this.handleMoveSelectedItems}
                          />
                        )}
                        {filesView === 'tile' && (
                          <FilesTile
                            files={files}
                            handleMoveSelectedItems={this.handleMoveSelectedItems}
                          />
                        )}
                      </>
                    )}
                  </div>
                ) : (
                  (
                    noFilesFound && collections.length === 0 &&
                    (!collection || !collection.smart)
                  ) && (
                    isMini() ? (
                      <MiniEmptyCollection />
                    ) : (
                      <>
                        {(search || selectedFilters.length > 0) ? (
                          <EmptySearch />
                        ) : (
                          <EmptyCollection asset="file" />
                        )}
                      </>
                    )
                  )
                )}
                {(files.length === 0 && noFilesFound && collections.length === 0 &&
                  (collection && collection.smart)) && (
                    <EmptySmartCollection />
                )}
                {(!filesLoading && !this.isSingleFile()) && (
                  <Waypoint
                    bottomOffset="-400px"
                    onEnter={() => {
                      if (!filesEnd) {
                        dispatch(fetchFiles());
                      }
                    }}
                  />
                )}
                {(filesLoading && (!initialCollectionsLoading || isAllFilesPage())) && (
                  <Loading />
                )}
              </>
              )}
            </div>
            <CollectionAddModal />
          </Container>
          <CollectionPreview />
          {!isMini() && (
            <CustomDragLayer />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  files: state.Files.files,
  filesTotal: state.Files.filesTotal,
  filesLoading: state.Files.loading,
  filesEnd: state.Files.end,
  filesParams: state.Files.params,
  selectedFiles: state.Files.selectedFiles,
  search: state.Search.search,
  selectedFilters: state.Files.selectedFilters,
  collection: state.Collections.collection,
  collections: state.Collections.collections,
  selectedCollections: state.Collections.selectedCollections,
  collectionsPage: state.Collections.params.page,
  collectionsLoading: state.Collections.collectionsLoading,
  sidebarCollectionOpen: state.Collections.sidebarCollectionOpen,
  reorderingMode: state.Files.reorderingMode,
});

Files.propTypes = {
  intl: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  files: PropTypes.array.isRequired,
  filesTotal: PropTypes.number.isRequired,
  filesLoading: PropTypes.bool.isRequired,
  filesEnd: PropTypes.bool.isRequired,
  filesParams: PropTypes.object.isRequired,
  selectedFiles: PropTypes.array.isRequired,
  search: PropTypes.string,
  selectedFilters: PropTypes.array.isRequired,
  collection: PropTypes.object,
  collections: PropTypes.array.isRequired,
  selectedCollections: PropTypes.array.isRequired,
  collectionsPage: PropTypes.number.isRequired,
  collectionsLoading: PropTypes.bool.isRequired,
  sidebarCollectionOpen: PropTypes.bool.isRequired,
  reorderingMode: PropTypes.bool.isRequired,
};

Files.defaultProps = {
  collection: null,
  search: null,
};

export default withRouter(injectIntl(connect(mapStateToProps)(Files)));
